import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

class Table extends React.Component {
  render() {
    const { columns, sortColumn, onSort, data } = this.props;
    return (
      <table className="table table-striped table-sm ">
        <TableHeader
          columns={columns}
          sortColumn={sortColumn}
          onSort={onSort}
        />
        <TableBody data={data} columns={columns} />
      </table>
    );
  }
}

export default Table;
